module.exports = __webpack_public_path__ + "img/umbrella-drizzle.b35086ce.svg";